module.exports = __webpack_public_path__ + "static/tomas-f04c0a3cf2538d0bc16c91bc46e05e59.png";